export enum EntityType {
  WORKSPACE = 'WORKSPACE',
  ORGANIZATION = 'ORGANIZATION'
}
